import store from '@/store'
import { DueDiligenceApprovalMode, EndangeredSpeciesMode } from '@/utils/Enumerations.js'

function currentMode () {
  return store.getters['user/companyInfo']?.endangeredSpeciesMode ?? null
}

export function endangeredSpeciesEnabled () {
  const mode = currentMode()
  return mode !== null && mode !== EndangeredSpeciesMode.None.value
}

export function speciesLayerEnabled () {
  return currentMode() === EndangeredSpeciesMode.SpeciesLayer.value
}

export function manualModeEnabled () {
  return currentMode() === EndangeredSpeciesMode.Manual.value
}

function currentApprovalMode () {
  return store.getters['user/companyInfo']?.dueDiligenceApprovalMode ?? DueDiligenceApprovalMode.None.value
}

export function dueDiligenceApprovalEnabled () {
  return endangeredSpeciesEnabled() && currentApprovalMode() !== DueDiligenceApprovalMode.None.value
}

export function dueDiligenceGatesBids () {
  return endangeredSpeciesEnabled() && currentApprovalMode() === DueDiligenceApprovalMode.Strict.value
}
